import { Box, CssBaseline, IconButton } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import PageviewIcon from "@material-ui/icons/Pageview";
import MaterialTable from "material-table";
import { useHistory } from "react-router";
import LabelsContext from "../../../lang/LabelsContext";
import EnumDesignation from "../../../utils/enum/EnumDesignation";
import EnumReviewStatus from "../../../utils/enum/EnumReviewStatus";
import { getReviewStatus } from "../../../utils/Utils";
import CopyText from "../../system/copy-text/CopyText";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import ReviewHistoryService, { ReviewHistoryServiceType } from "./ReviewHistoryService";

export default function ReviewHistory() {
  const { Labels } = LabelsContext();

  const { articleList }: ReviewHistoryServiceType = ReviewHistoryService();

  const history = useHistory();

  const statusView = (status: string) => {
    if (
      [
        EnumReviewStatus.DRAFT,
        EnumReviewStatus.NEW_ARTICLE,
        EnumReviewStatus.ASSOCIATE_EDITOR,
        EnumReviewStatus.RETURNED_TO_EDITOR,
      ].includes(status)
    ) {
      return "In progress";
    }
    return getReviewStatus(status, Labels);
  };

  return (
    <>
      <CssBaseline />
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            field: "articleId",
            title: Labels.ARTICLE_ID,
            customSort: (a, b) => {
              let [aFirst, aSecond] = a.articleId.split("-");
              let [bFirst, bSecond] = b.articleId.split("-");
              aFirst = parseInt(aFirst);
              aSecond = parseInt(aSecond);
              bFirst = parseInt(bFirst);
              bSecond = parseInt(bSecond);

              if (aFirst === bFirst) {
                return aSecond - bSecond;
              }

              return aFirst - bFirst;
            },

            cellStyle: { width: "10%" },
          },
          {
            field: "articleTitle",
            title: Labels.TITLE,
            cellStyle: { width: "60%" },
            render: (rowData: any) => (
              <Box display="flex" alignItems="center">
                <div>{rowData.articleTitle}</div>
                <CopyText text={`#${rowData.articleId} ${rowData.articleTitle}`} />
              </Box>
            ),
          },
          {
            field: "status",
            title: Labels.MANUSCRIPT,
            cellStyle: { width: "15%" },
            render: (rowData: any) => {
              if (!rowData.files?.some((f: any) => f.type === EnumDesignation.FULL_MANUSCRIPT)) {
                return null;
              }

              return (
                <Link
                  href={rowData.files?.find((f: any) => f.type === EnumDesignation.FULL_MANUSCRIPT)?.location}
                  color="inherit"
                  component="a"
                  target="_blank"
                >
                  {Labels.MANUSCRIPT}
                </Link>
              );
            },
          },
          {
            field: "articleReviewer.status",
            title: Labels.REVIEW_STATUS,
            cellStyle: { width: "15%" },
          },
          {
            title: Labels.ARTICLE_STATUS,
            cellStyle: { width: "15%" },
            render: (rowData: any) => <div>{statusView(rowData.status)}</div>,
          },
          {
            title: Labels.VIEW,
            sorting: false,
            cellStyle: { width: "15%" },
            render: (rowData: any) => (
              <IconButton onClick={() => history.push(`${rowData.id}/review/${rowData.articleReviewer.id}`)}>
                <PageviewIcon fontSize="medium" />
              </IconButton>
            ),
          },
        ]}
        title={Labels.REVIEW_HISTORY}
        data={articleList}
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
          sorting: true,
          thirdSortClick: false,
        }}
      />
    </>
  );
}
